module.exports = __webpack_public_path__ + "img/kcs.6f08f2b0.svg";